import { SearchInput } from 'react-admin'

const RetailerTagListFilters = [
    <SearchInput variant="outlined" placeholder="Search name" source="tag" alwaysOn />
]

export default RetailerTagListFilters
